import { interpolate, useCurrentFrame } from 'remotion';

// Constants
import { CLAMP_RIGHT } from '@/constants/animations';
import { TREE_ANIMATION } from '../../constants';

export const TreeAnimation = () => {
  const frame = useCurrentFrame();

  // Fades in quickly so sway is visible at full opacity
  const opacity = interpolate(
    frame,
    [0, TREE_ANIMATION.fadeInDuration],
    [0, 1],
    CLAMP_RIGHT,
  );

  // Sway runs from frame 0, opacity masks it during early frames
  const rotation =
    Math.sin((frame / TREE_ANIMATION.swayPeriodFrames) * 2 * Math.PI) *
    TREE_ANIMATION.swayMaxDeg;

  return (
    <svg
      className="absolute inset-0 w-full h-full"
      viewBox="0 0 1920 1080"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ opacity }}
    >
      <g transform="translate(1600, 82)">
        <svg width="321" height="664" viewBox="0 0 321 664" overflow="hidden">
          <g
            fill={TREE_ANIMATION.color}
            style={{
              transformBox: 'fill-box',
              transformOrigin: 'bottom center',
              transform: `rotate(${rotation}deg)`,
            }}
          >
            {TREE_ANIMATION.paths.map((d, index) => (
              <path key={index} d={d} />
            ))}
          </g>
        </svg>
      </g>
    </svg>
  );
};
